var React = require('react');

function FolderTree (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 416V16A16 16 0 0 1 16 0h32a16 16 0 0 1 16 16v80h192v64H64v224h192v64H32a32 32 0 0 1-32-32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M544 320H432l-32-32h-80a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V352a32 32 0 0 0-32-32zm0-288H432L400 0h-80a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32z","className":"fa-primary","key":2})]);
}

FolderTree.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = FolderTree;

FolderTree.default = FolderTree;
